import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import * as React from "react";

// Data format: [{label: '0-24 hrs', values: {Open:10, InProgress:5, ...}}, ...]
export default function TicketAgingBar({
  title = "Ticket Aging",
  groups = [],
  seriesLabels = [],
}) {
  const xLabels = groups.map((g) => g.label);
  const series = seriesLabels.map((sLabel, index) => ({
    id: index,
    label: sLabel,
    stack: "A",
    data: groups.map((g) => g.values?.[sLabel] ?? 0),
  }));

  return (
    <Box sx={{ height: "100%", border: "none" }}>
      {/* <Typography component="h2" variant="subtitle2" gutterBottom>
          {title}
        </Typography> */}
      <BarChart
        xAxis={[{ scaleType: "band", data: xLabels }]}
        series={series}
        height={250}
        margin={{ left: 40, right: 10, top: 10, bottom: 20 }}
        grid={{ horizontal: true }}
        slotProps={{ legend: { hidden: true } }}
      />
    </Box>
  );
}
